//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        id: Number
    },

    data () {
        return {
            loading: false,
            buttonLoading: false,
            publishDialogVisible: false,
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            item: {},
            form: {},
            rules: {},
        };
    },

    computed: {
        formMethod () {
            return (this.form && this.form.id) ? 'put' : 'post';
        },
        formUrl () {
            return 'faqs' + (this.form && this.form.id ? '/' + this.form.id : '');
        }
    },

    watch: {
        item: {
            handler () {
                this.$set(this.form, 'id', this.item && this.item.id ? this.item.id : undefined);
                this.$set(this.form, 'title', this.item && this.item.title ? this.item.title : '');
                this.$set(this.form, 'content', this.item && this.item.content ? this.item.content : '');
                this.$set(this.form, 'published', this.item && this.item.published ? this.item.published : false);
                this.$set(this.form, 'published_at', this.item.published_at ? this.$helper.getDate(this.item.published_at) : '');
            },
            deep: true,
            immediate: true
        }
    },

    mounted () {
        this.init();
    },

    methods: {
        async init () {
            try {
                this.loading = true;

                if (this.id !== undefined) {
                    await this.loadFAQ();
                }
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: this.$lang.get('std.ajaxError')
                });
            } finally {
                this.loading = false;
            }
        },
        loadFAQ () {
            return new Promise((resolve, reject) => {
                axios.get(`faqs/${this.id}`, {
                    params: {
                        with: []
                    }
                }).then(response => {
                    if (response && response.data) {
                        this.item = response.data;
                    }

                    resolve();
                }).catch(() => reject());
            });
        },
        create () {
            this.submit(this.$lang.get('models.faqs.created'));
        },
        update () {
            if(this.form.published_at) {
                this.form.published_at = this.item.published_at;
            }
            this.submit(this.$lang.get('models.faqs.updated'));
        },
        updateAndPublish () {
            if (!this.form.published_at) {
                this.form.published_at = moment();
            }
            this.form.published = true;
            this.form.published_at = moment.utc(this.form.published_at).format('YYYY-MM-DD HH:mm:ss');
            let message = this.isInFuture(this.form.published_at) ? this.$lang.get('models.faqs.tobe-published') : this.$lang.get('models.faqs.published');
            this.submit(message);
        },
        updateAndUnpublish () {
            this.form.published = false;
            this.form.published_at = '';
            this.submit(this.$lang.get('models.faqs.unpublished'));
        },
        async submit (successMessage = '') {
            try {
                this.buttonLoading = true;

                await this.submitFaq();

                this.publishDialogVisible = false;
                this.buttonLoading = false;

                this.$message({
                    type: 'success',
                    message: successMessage
                });
            } catch (error) {
                this.publishDialogVisible = false;
                this.buttonLoading = false;
            }
        },
        submitFaq () {
            return new Promise((resolve, reject) => {
                axios({
                    method: this.formMethod,
                    url: this.formUrl,
                    data: this.form
                }).then(response => {
                    this.form.id = response.data.faqs.id;
                    this.$refs.form.clearValidate();
                    resolve();
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.$helper.FormValidator.validate(this.$refs.form, this.form, this.rules, error.response.data.errors);
                    }

                    reject();
                });
            });
        },
        isInFuture (date) {
            let now = moment().utc();
            let utcDate = moment.utc(date, 'YYYY-MM-DD HH:mm:ss');

            return moment(now).isBefore(utcDate);
        }
    }
};
